// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoAzureAD } from '../../../assets/images/Logos/logo-azure-AD.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoAzureADIcon = /* @__PURE__ */ withLogoClass(LogoAzureAD);
